// extracted by mini-css-extract-plugin
module.exports = {"balloon":"_7a3fb80146--balloon--U1zR9","icon":"_7a3fb80146--icon--tkiyn"};